// 用户相关
const user = [
  {
    path: '/user/edit', // 修改密码
    component: () => import(/* webpackChunkName: "useredit" */ '@/views/user/editMsg'),
    meta: {
      title: '修改密码',
    },
  },
];

export default user;
